
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoajantaellora() {



  const cardData =
  {
    keyword: 'Pune to Ajanta Ellora Cabs',
    heading: 'AB Ghule Cabs: Pune to Ajanta Ellora Cabs',
    headingDescription: 'AB Ghule Cabs offers safe, comfortable, and reliable Pune to Ajanta Ellora cab services for a seamless and enjoyable journey to these historic and cultural sites. Whether you are traveling for sightseeing, history, or spiritual exploration, our fleet of well-maintained vehicles and professional drivers will ensure a smooth ride. Experience the mesmerizing caves and rich heritage of Ajanta and Ellora with our hassle-free service. Pune to Ajanta Ellora is approximately 250 km.',

    top: 'Top Places to Visit in Ajanta Ellora with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Ajanta Caves",
          description: "A UNESCO World Heritage Site, the Ajanta Caves are famous for their ancient Buddhist rock-cut temples and exquisite murals. The caves date back to the 2nd century BCE and are a testament to India’s rich Buddhist heritage, offering visitors a glimpse into ancient Buddhist culture and art."
        },
        {
          title: "Ellora Caves",
          description: "Ellora is another UNESCO World Heritage Site and is known for its stunning rock-cut temples dedicated to Hinduism, Buddhism, and Jainism. The Kailasa Temple, the largest monolithic structure in the world, is a highlight here, showcasing the grandeur and intricate carvings of ancient Indian architecture."
        },
        {
          title: "Kailasa Temple",
          description: "Located in Ellora, the Kailasa Temple is an architectural marvel carved out of a single rock. The intricate carvings and grandeur of this temple make it a must-visit landmark in the Ellora Caves, offering a magnificent example of Indian rock-cut architecture."
        },
        {
          title: "Buddhist Monasteries at Ajanta",
          description: "Explore the serene Buddhist monasteries at Ajanta, which offer insight into the ancient monastic life and showcase impressive rock-cut architecture along with frescoes depicting the life of Lord Buddha. These monasteries provide a peaceful environment for reflection and a deeper understanding of Buddhist teachings."
        },
        {
          title: "Grishneshwar Temple",
          description: "Situated near Ellora, Grishneshwar Temple is one of the 12 Jyotirlinga shrines dedicated to Lord Shiva. The temple is an important pilgrimage site and a peaceful location for spiritual reflection, drawing devotees from across the country for its religious significance."
        },
        {
          title: "Daulatabad Fort",
          description: "Located near Ellora, Daulatabad Fort is known for its historical significance and panoramic views. The fort’s complex architecture and strategic location make it a popular spot for history enthusiasts, offering a deep dive into medieval Indian military architecture."
        },
        {
          title: "Ajanta Viewpoint",
          description: "A perfect spot for photography and panoramic views, the Ajanta Viewpoint offers a scenic view of the Ajanta Caves and the surrounding landscape. It is a great place to capture the beauty of the area, providing an excellent perspective of the caves and the lush greenery."
        },
        {
          title: "Ellora Waterfalls",
          description: "Located near the Ellora Caves, the Ellora Waterfalls is a picturesque spot for nature lovers. It’s an ideal place to relax and enjoy the natural beauty surrounding the caves, offering a refreshing experience for visitors seeking tranquility."
        },
        {
          title: "Aurangabad Caves",
          description: "Located near Aurangabad, these caves are lesser-known compared to Ajanta and Ellora but are still remarkable for their ancient Buddhist rock-cut temples and stunning architecture. The caves are a hidden gem, offering a peaceful and historic site for exploration."
        },
        {
          title: "Panchakki",
          description: "Situated in Aurangabad, Panchakki is an ancient watermill built to grind grain. The complex is an interesting site to explore for its engineering marvels and its association with Sufi Saint, Baba Shah Musafir, showcasing the ingenious use of water-powered machinery in the 17th century."
        }
      ],


   services: [
    {
      "name": "Ajanta Ellora Caves Tour Package from Pune",
      description: "Explore the majestic Ajanta Ellora Caves with our customized tour packages from Pune. Whether you're planning a short trip or a full-day excursion, we offer a variety of packages to make your journey comfortable and memorable. The Ajanta and Ellora caves are UNESCO World Heritage Sites known for their intricate architecture and historical significance. Book your tour with us for a seamless experience."
    },
    {
      "name": "Ajanta Ellora Tour from Pimpri Chinchwad",
      description: "If you're based in Pimpri Chinchwad and looking to visit the Ajanta Ellora Caves, AB Ghule Cabs offers dedicated services for this trip. Our well-maintained vehicles and professional drivers ensure that your trip is smooth and enjoyable. We also provide flexible packages that cater to your travel needs, whether for a day trip or a weekend getaway."
    },
    {
      "name": "Trip to Ajanta Ellora Caves from Pune",
      description: "Book a trip to the famous Ajanta Ellora Caves from Pune with AB Ghule Cabs. We provide convenient and reliable transportation options, including cabs and rentals, to take you to these historical sites. Our drivers are well-versed with the route, ensuring timely and safe travel."
    },
    {
      "name": "Pune to Ajanta Ellora Cab Service",
      description: "Our Pune to Ajanta Ellora cab service offers comfort and convenience for your journey to these iconic caves. Whether you’re traveling solo, with friends, or with family, we provide a wide range of vehicles to suit your group size. Enjoy the scenic drive as you head towards one of India’s most fascinating historical sites."
    },
    {
      "name": "Pune to Ajanta Ellora Cab Booking",
      description: "Booking a cab from Pune to Ajanta Ellora is easy with AB Ghule Cabs. You can reserve your cab online or by calling our customer support team. We offer flexible pick-up options and ensure a smooth ride with well-maintained vehicles for your comfort."
    },
    {
      "name": "Pune to Ajanta Ellora Cab Fare",
      description: "The cab fare for Pune to Ajanta Ellora depends on the vehicle type and the number of passengers. We offer competitive prices with transparent pricing, so you don't have to worry about hidden charges. You’ll get a reliable estimate for your journey before you book."
    },
    {
      "name": "Pune to Ajanta Verul Cab Fare",
      description: "For those specifically visiting the Ajanta Verul caves, AB Ghule Cabs provides affordable and transparent fare options. Whether you're booking an economy car, an SUV, or a luxury vehicle, we ensure the pricing suits your budget."
    },
    {
      "name": "Pune to Ajanta Ellora Innova Cab Fare",
      description: "Travel comfortably in an Innova Crysta from Pune to Ajanta Ellora with AB Ghule Cabs. The fare for an Innova ride depends on the distance, but it is one of the best options for group travelers looking for space and comfort. The Innova offers a luxurious ride with ample space for passengers and luggage."
    },
    {
      "name": "Pune to Ajanta Ellora Ertiga Cab",
      description: "If you're traveling with a smaller group, the Ertiga is an ideal choice for your Pune to Ajanta Ellora trip. This affordable and comfortable vehicle is perfect for up to six passengers, offering a smooth ride to the caves."
    },
    {
      "name": "Pune to Ajanta Ellora Tempo Traveller on Rent",
      description: "For larger groups or family trips, AB Ghule Cabs offers tempo traveller rentals for your Ajanta Ellora visit. Our tempo travellers can accommodate 12-15 passengers comfortably, providing ample space for a group outing. We ensure a safe and enjoyable journey for everyone on board."
    },
    {
      "name": "Pune to Ajanta Ellora Sedan Cab Service",
      description: "For smaller groups or solo travelers, our sedan cab service is a great option for the Pune to Ajanta Ellora trip. The sedan offers comfort, privacy, and an efficient ride, making it a popular choice for a smooth journey to the caves."
    },
    {
      "name": "Pune to Ajanta Ellora Mini Bus on Rent",
      description: "If you're traveling with a larger group, AB Ghule Cabs offers mini buses on rent for your trip to the Ajanta Ellora caves. Our mini buses are equipped with all the necessary amenities, ensuring a comfortable and safe journey for everyone."
    },
    {
      "name": "Pune to Ajanta Ellora Cabs Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Ajanta Ellora Cab. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Ajanta Ellora Caves Tour Package from Pune", "-Ajanta Ellora Tour from Pimpri Chinchwad"],
    ["Trip to Ajanta Ellora Caves from Pune", "-Pune to Ajanta Ellora Cab Service"],
    ["Pune to Ajanta Ellora Cab Booking", "-Pune to Ajanta Ellora Cab Fare"],
    ["Pune to Ajanta Verul Cab Fare", "-Pune to Ajanta Ellora Innova Cab Fare"],
    ["Pune to Ajanta Ellora Ertiga Cab", "-Pune to Ajanta Ellora Tempo Traveller on Rent"],
    ["Pune to Ajanta Ellora Sedan Cab Service", "-Pune to Ajanta Ellora Mini Bus on Rent"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Comfortable and Relaxing Journey",
      WhyChoosedescription: "Experience a comfortable and enjoyable ride with AB Ghule Cabs from Pune to the magnificent Ajanta Ellora caves. Our well-maintained, air-conditioned vehicles provide you with a smooth and relaxing journey, so you can focus on exploring these historical wonders."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Our drivers are not only experienced but also well-versed with the Pune to Ajanta Ellora route. They ensure safe and timely travel, providing excellent customer service throughout the trip."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "AB Ghule Cabs offers affordable and transparent pricing for your Pune to Ajanta Ellora cab ride. We provide upfront pricing with no hidden charges, ensuring you get value for your money."
    },
    {
      WhyChooseheading: "Timely and Punctual Service",
      WhyChoosedescription: "We understand the importance of punctuality. Whether you're traveling for a day trip or a longer visit, our drivers are always on time, ensuring that you reach your destination as scheduled without any delays."
    },
    {
      WhyChooseheading: "Safe and Secure Travel",
      WhyChoosedescription: "Your safety is our top priority. All our vehicles are regularly serviced and equipped with safety features, including GPS tracking for real-time monitoring during the journey. Our drivers are trained to follow all road safety protocols."
    },
    {
      WhyChooseheading: "Flexible Booking Options",
      WhyChoosedescription: "Booking your Pune to Ajanta Ellora cab is simple and convenient. You can book online via our website or app, or contact our customer service team for personalized assistance."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "We offer round-the-clock services, making it easy to book your cab at any time of day or night. Whether you need a morning departure or a late-night ride, we are here to cater to your needs."
    }
  ]
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab from Pune to Ajanta Ellora?',
      answer: 'Booking a cab is easy! You can book through our website, mobile app, or simply call our customer service to reserve your ride.',
    },
    {
      id: 'FAQ2',
      question: 'How long does the journey from Pune to Ajanta Ellora take?',
      answer: 'The distance from Pune to Ajanta Ellora is approximately 240 kilometers and the journey typically takes around 5 to 6 hours, depending on traffic conditions.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for this journey?',
      answer: 'We offer a range of vehicles, including sedans, SUVs, and luxury cars, to suit your needs and preferences for the trip. All our vehicles are comfortable and well-maintained.',
    },
    {
      id: 'FAQ4',
      question: 'Are there any additional charges for the Pune to Ajanta Ellora trip?',
      answer: 'Our pricing is transparent, with no hidden fees. Additional charges may apply for extended travel time, detours, or special requests. Any extra charges will be communicated to you before confirming your booking.',
    },
    {
      id: 'FAQ5',
      question: 'Can I book a round-trip cab from Pune to Ajanta Ellora?',
      answer: 'Yes, we offer both one-way and round-trip services. You can plan your entire trip with us, and we’ll ensure you have a comfortable return journey as well.',
    },
    {
      id: 'FAQ6',
      question: 'How do I pay for my Pune to Ajanta Ellora cab ride?',
      answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments through our app or website for your convenience.',
    },
    {
      id: 'FAQ7',
      question: 'Are the drivers experienced with the Pune to Ajanta Ellora route?',
      answer: 'Yes, our drivers are experienced and familiar with the Pune to Ajanta Ellora route. They will ensure a smooth and safe journey while guiding you to your destination.',
    },
    {
      id: 'FAQ8',
      question: 'Can I modify or cancel my booking?',
      answer: 'Yes, you can modify or cancel your booking through our website or app. If you need assistance, our customer service team is always available to help.',
    },
    {
      id: 'FAQ9',
      question: 'Is AB Ghule Cabs available for sightseeing in Ajanta Ellora?',
      answer: 'Yes, our drivers are happy to assist you with sightseeing at Ajanta and Ellora caves. We can also provide guidance on the best places to visit within the caves during your trip.',
    },
    {
      id: 'FAQ10',
      question: 'Do you offer additional services like guides for Ajanta Ellora?',
      answer: 'While our drivers are knowledgeable about the route, we do not provide official guides for Ajanta Ellora. However, we can recommend local guides who can help enhance your experience at the caves.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Vishal Agarwal',
      feedback: 'I had a fantastic trip from Pune to Ajanta Ellora with AB Ghule Cabs. The vehicle was comfortable, and the driver was very knowledgeable about the area. It was a smooth and pleasant journey, and I highly recommend this service for anyone planning a visit to the caves.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Neha Desai',
      feedback: 'AB Ghule Cabs made my trip to Ajanta Ellora seamless. The booking was easy, and the driver was punctual. The entire experience was stress-free, and I was able to enjoy the beautiful caves without worrying about transportation. Definitely will use their services again.',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Ajanta Ellora Cabs | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs</title>
  <meta name="description" content="Book your Pune to Ajanta Ellora Cabs with AB Ghule Cabs. Offering affordable, reliable taxi services and car rentals for one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Ajanta Ellora caves Tour Package from Pune, Ajanta Ellora tour from Pimpri Chinchwad, Trip to Ajanta Ellora Caves from Pune, Pune to Ajanta Ellora Cab Service, Pune to Ajanta Ellora Cab Booking, Pune to ajanta ellora cab fare, Pune to Ajanta Verul Cab fare, pune to ajanta ellora innova cab fare, pune to ajanta ellora ertiga cab, pune to ajanta ellora tempo traveller on Rent, pune to ajanta ellora sedan cab service, Pune to Ajanta Ellora Mini Bus On Rent" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Ajanta Ellora Cabs | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs" />
  <meta property="og:description" content="Book your Pune to Ajanta Ellora Cabs with AB Ghule Cabs. Offering affordable, reliable taxi services and car rentals for one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-ajanta-ellora-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-ajanta-ellora-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Ajanta Ellora Cabs",
        description: "Book your Pune to Ajanta Ellora Cabs with AB Ghule Cabs. Offering affordable, reliable taxi services and car rentals for one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-ajanta-ellora-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-ajanta-ellora-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-ajanta-ellora-cabs.jpg",
        "priceRange": "₹5000 - ₹12000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-ajanta-ellora-cabs",
          "priceCurrency": "INR",
          "price": "5000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.6",
          "reviewCount": "120"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Suresh M"
            },
            "datePublished": "2024-11-10",
            "reviewBody": "The trip to Ajanta Ellora was amazing! The cab was comfortable, and the driver was very professional. Highly recommend AB Ghule Cabs for long-distance trips!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha P"
            },
            "datePublished": "2024-09-25",
            "reviewBody": "Great service for our family trip to Ajanta Ellora. The cab was spacious, and we had a smooth journey. Excellent customer service!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Ajanta Ellora Cabs",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-ajanta-ellora-cabs"
        },
        "keywords": "Ajanta Ellora caves Tour Package from Pune, Ajanta Ellora tour from Pimpri Chinchwad, Trip to Ajanta Ellora Caves from Pune, Pune to Ajanta Ellora Cab Service, Pune to Ajanta Ellora Cab Booking, Pune to ajanta ellora cab fare, Pune to Ajanta Verul Cab fare, pune to ajanta ellora innova cab fare, pune to ajanta ellora ertiga cab, pune to ajanta ellora tempo traveller on Rent, pune to ajanta ellora sedan cab service, Pune to Ajanta Ellora Mini Bus On Rent"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/30.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetoajantaellora;